import '../components/product/product-image-carousel';
import '../components/product/product-accordions';
import '../components/product/product-form';
import '../components/product/upsell-form';
import '../components/product/product-reviews';
import '../components/product/product-subscription';
